var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import Filter from '../../utils/filter';
import Paginator from '../Paginator';
import underline from '../../utils/underline';
import paginatorConfig from '../../configure/paginatorConfig';
import localesReplacement from '../../utils/localesReplacement';
import DOMPurify from 'dompurify';
var cx = classnames.bind(style);
function FilterResult(props) {
    var dataList = props.dataList, vehicleType = props.vehicleType, make = props.make, model = props.model, year = props.year, className = props.className, sort = props.sort, value = props.value, onSelect = props.onSelect, replacements = props.replacements;
    var _a = useState(), vehicles = _a[0], setVehicles = _a[1];
    var _b = useState(0), pageIndex = _b[0], setPageIndex = _b[1];
    var _c = useState(0), mPageIndex = _c[0], setMPageIndex = _c[1];
    var limit = paginatorConfig.LIMIT;
    var mobileVehicles = _.take(vehicles, limit * (mPageIndex + 1));
    useEffect(function () {
        var _dataList = new Filter(dataList)
            .vehicleType(vehicleType)
            .manufacturer(make)
            .model(model)
            .year(year)
            .value();
        if (sort) {
            setVehicles(_.orderBy(_dataList, ['make', 'model', 'yearFrom', 'yearTo'], ['asc', 'asc', 'desc', 'desc']));
        }
        else {
            setVehicles(_dataList);
        }
        setPageIndex(0);
        setMPageIndex(0);
    }, [dataList, vehicleType, make, model, year]);
    var changeIndex = function (index) {
        setPageIndex(index);
    };
    var showMore = function () {
        setMPageIndex(mPageIndex + 1);
    };
    return (_jsx(_Fragment, { children: !_.isEmpty(vehicles) && (_jsxs("div", __assign({ className: cx('result', {
                'with-paginator': vehicles && Math.ceil(vehicles.length / limit) > 1,
            }, "".concat(className)) }, { children: [_jsx("div", __assign({ className: cx('result-heading') }, { children: _jsxs("ul", { children: [_jsx("li", { children: localesReplacement(replacements, 'Model') }, void 0), _jsx("li", { children: localesReplacement(replacements, 'Description') }, void 0), _jsx("li", { children: localesReplacement(replacements, 'Year') }, void 0), _jsx("li", {}, void 0)] }, void 0) }), void 0), _.chain(vehicles)
                    .chunk(limit)
                    .get(pageIndex)
                    .map(function (vehicle) { return (_jsx("div", __assign({ className: cx('result-row', 'desktop'), onClick: function () {
                        if (onSelect) {
                            onSelect(vehicle['id'], vehicle['model'], vehicle.vehicleType);
                            sessionStorage.setItem('vehicleType', vehicle.vehicleType);
                        }
                    } }, { children: _jsxs("ul", { children: [_jsx("li", { dangerouslySetInnerHTML: {
                                    __html: DOMPurify.sanitize("".concat(underline(vehicle['make'], value), "  ").concat(vehicle['model']
                                        ? underline(vehicle['model'], value)
                                        : '')),
                                } }, void 0), _jsx("li", { children: vehicle['type'] }, void 0), _jsx("li", { children: "".concat(vehicle['yearFrom'], " - ").concat(!_.isNull(vehicle['yearTo']) ? vehicle['yearTo'] : '') }, void 0), _jsxs("li", { children: [_jsx("span", { className: cx('expend') }, void 0), _jsx("button", __assign({ className: cx('recommonended-btn') }, { children: localesReplacement(replacements, 'View recommended oils') }), void 0)] }, void 0)] }, void 0) }), vehicle.id)); })
                    .value(), _.map(mobileVehicles, function (vehicle, index) { return (_jsx("div", __assign({ className: cx('result-row', 'mobile'), onClick: function () {
                        if (onSelect) {
                            onSelect(vehicle['id'], vehicle['model'], vehicle.vehicleType);
                            sessionStorage.setItem('vehicleType', vehicle.vehicleType);
                        }
                    } }, { children: _jsxs("ul", { children: [_jsx("li", { dangerouslySetInnerHTML: {
                                    __html: DOMPurify.sanitize("".concat(underline(vehicle['make'], value), "  ").concat(vehicle['model']
                                        ? underline(vehicle['model'], value)
                                        : null)),
                                } }, void 0), _jsx("li", { children: vehicle['type'] }, void 0), _jsx("li", { children: "".concat(vehicle['yearFrom'], " - ").concat(vehicle['yearTo']) }, void 0)] }, void 0) }), index)); }), !!vehicles && mobileVehicles.length < vehicles.length && (_jsx("div", __assign({ className: cx('btn-show-more') }, { children: _jsx("span", __assign({ onClick: showMore }, { children: localesReplacement(replacements, 'Show more') }), void 0) }), void 0)), !!vehicles && (_jsx(Paginator, { index: pageIndex, changeIndexHandler: changeIndex, total: Math.ceil(vehicles.length / limit) }, void 0))] }), void 0)) }, void 0));
}
export default FilterResult;
